import axios from '../axios/axios';
import {
  PI_DATA_REQUEST,
  PI_DATA_SUCCESS,
  PI_DATA_FAIL,
} from '../constants/proposedInsuredConstants';

export const proposedInsuredAction = () => async (dispatch) => {
  try {
    dispatch({ type: PI_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s3',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: PI_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }

    dispatch({
      type: PI_DATA_FAIL,
      payload: error,
    });
  }
};
